export default __webpack_public_path__ + "static/bonnie-8831b595867e2ff493ebe7b02e9b8f4b.png";